module.exports = __webpack_public_path__ + "img/Radbagger.4b1deb52.svg";